import { createStore as reduxCreateStore } from "redux";
import { OPEN_MENU, CLOSE_MENU, SET_SEARCH_VALUE } from './constants';

const reducer = (state, action) => {
  switch (action.type) {
    case OPEN_MENU:
      return Object.assign({}, state, {
        openMenu: true,
      })
    case CLOSE_MENU:
      return Object.assign({}, state, {
        openMenu: false,
      })
    case SET_SEARCH_VALUE:
      return Object.assign({}, state, {
        searchValue: action.payload,
        isSearching: typeof action.payload === 'string' && action.payload.trim().length > 0,
      })
    default:
      return state;
  }
}

const initialState = {
  openMenu: true,
  searchValue: '',
  isSearching: false,
};

const createStore = () => reduxCreateStore(reducer, initialState)
export default createStore;